import { useQuery } from "react-query";
import { api } from "../utils/api/api";

const getCollectionNoticeText = async () => {
  try {
    const { data } = await api.get(
      `${process.env.REACT_APP_API_URL}tracs_v3/scholarships/Scholarships_unprotected_api/getCollectionNotice`
    );
    return data;
  } catch (err) {
    throw new Error(err);
  }
};

export function useCollectionNotice() {
  return useQuery("text", () => getCollectionNoticeText());
}
